import { Component, OnInit, Input } from '@angular/core';
import { TimeFrameForm } from '../../dto/timeFrameForm';
import { ClickStreamService } from 'src/app/services/click-stream.service';

@Component({
  selector: 'app-time-frame-picker',
  templateUrl: './time-frame-picker.component.html',
  styleUrls: ['./time-frame-picker.component.scss']
})
export class TimeFramePickerComponent implements OnInit {

  minDate: Date = new Date();

  @Input() timeFrame: TimeFrameForm;

  repeatOptions:Array<Object> = [
      {repeatDuration: 'Daily', pluralVersion: 'day(s)'},
      {repeatDuration: 'Weekly', pluralVersion: 'week(s)'},
      {repeatDuration: 'Monthly', pluralVersion: 'month(s)'},
      {repeatDuration: 'Yearly', pluralVersion: 'year(s)'}
  ];

  repeatWeekOfMonthOptions: Array<Object> = [
    { display: '1st', value: 1 }, { display: '2nd', value : 2 }, { display: '3rd', value: 3 }, { display: '4th', value : 4 }, { display: '5th', value : 5 }
  ]

  clickstreamPageTitle = "Push Chart - Time Frame";

  constructor(private clickstream : ClickStreamService) { }

  ngOnInit() {
    if (this.timeFrame && this.timeFrame.repeatDayOfWeek) this.setRepeatDayOfWeek(this.timeFrame.repeatDayOfWeek)
  }

  pluralVersionSelected = 'day(s)'

  repeatEveryCount = 0;
  endAfterCount = 1;
  endDateType = 'none';

  daysOfWeek = [ {abbr: 'M', full: 'Monday', value: 1}, {abbr: 'T', full: 'Tuesday', value: 2}, {abbr: 'W', full: 'Wednesday', value: 3},
   {abbr: 'Th', full: 'Thursday', value: 4}, {abbr:'F', full: 'Friday', value: 5} , {abbr:'Sa', full: 'Saturday', value: 6}, {abbr: 'Su', full: 'Sunday', value: 0}];

  setPluralVersion(value : string) {
    if (this.pluralVersionSelected != value) {
      this.pluralVersionSelected = value;
    } 
    this.validate();
    this.clickstream.send('set-repeat-type' + '-' + value, 'drop-down', this.clickstreamPageTitle, 'Select Repeat DropDown', '', true);
  }

  setRepeatDayOfWeek(dayOfWeek : number) {
    this.timeFrame.repeatDayOfWeek = dayOfWeek;
    this.clickstream.send('set-repeat-day-of-week', 'click', this.clickstreamPageTitle, 'Select Repeat Day Of Week', '', true);
  }

  handleClick(action : string, area) {
    this.clickstream.send(action, 'click', this.clickstreamPageTitle, area, '', true);
  }

  validate() {
    if (this.timeFrame.startDate != null && this.timeFrame.repeatInterval > -1) {
      if (this.timeFrame.endDate) this.timeFrame.valid = this.timeFrame.endDate != null
      if (!this.timeFrame.endDate) this.timeFrame.valid = true;
    } else {
      this.timeFrame.valid = false;
    }
  }

}
